<section class="cmn-innerpage-wrapper add-project-inventory">
  <h2 class="cmn-inner-heading">
    {{ stationaryId ? 'Update Stationary Item' : 'Create Stationary Item' }}
  </h2>

  <form [formGroup]="newSupplierForm" (ngSubmit)="onSubmit()">
    <div class="chart-account-form-wrapper">
      <div class="form-wrapper">
        <label for="">Item Name <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter Item Name"
            formControlName="name"
          />
          <mat-error *ngIf="newSupplierForm.get('name')?.hasError('required')">
            Item Name is required.
          </mat-error>
        </mat-form-field>
        <div class="custom-error">
          <span>
            <mat-error
              *ngIf="newSupplierForm.get('name')?.hasError('maxlength')"
            >
              Item Name must be at most 50 characters long.
            </mat-error>
          </span>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">Code <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter Code"
            formControlName="code"
            readonly
          />
          <mat-error *ngIf="newSupplierForm.get('code')?.hasError('required')">
            Code is required.
          </mat-error>
        </mat-form-field>
        <div class="custom-error">
          <span>
            <mat-error
              *ngIf="newSupplierForm.get('code')?.hasError('maxlength')"
            >
              Code must be at most 50 characters long.
            </mat-error>
          </span>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">Price <span class="red">*</span></label>
        <mat-form-field>
          <input matInput placeholder="0.00" formControlName="price" />
          <mat-error *ngIf="newSupplierForm.get('price')?.hasError('required')">
            Price is required.
          </mat-error>
          <mat-error
            *ngIf="newSupplierForm.get('price')?.hasError('maxlength')"
          >
            Price must be at most 50 characters long.
          </mat-error>
          <mat-error *ngIf="newSupplierForm.get('price')?.hasError('pattern')">
            Price must be a valid number (no alphabets or special characters).
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-wrapper">
        <label for="">Current Stock <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter Current Stock"
            formControlName="stock"
          />
          <mat-error *ngIf="newSupplierForm.get('stock')?.hasError('required')">
            Current Stock is required.
          </mat-error>
          <mat-error
            *ngIf="newSupplierForm.get('stock')?.hasError('maxlength')"
          >
            Current Stock must be at most 50 characters long.
          </mat-error>
          <mat-error *ngIf="newSupplierForm.get('stock')?.hasError('pattern')">
            Stock must be a whole number (no decimals, alphabets, or special
            characters).
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="submit-btn-wrapper">
      <button class="cmn-cancel-btn" type="button" (click)="onCancel()">
        Cancel
      </button>
      <button class="cmn-next-btn" type="submit">Save</button>
    </div>
  </form>
</section>
